import axios from 'axios';
import { getServiceApiKey } from '../utils/apiKey';

const BASE_API_URL = window?.appConfig?.REACT_APP_API_ENDPOINT;

/***
 *  Not in use...using sso login flow
 */

function login(clientId, clientSecret) {
    const requestObj = JSON.stringify({
        clientName: clientId,
    });
    return axios.post(BASE_API_URL + '/v2/token', requestObj, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": getServiceApiKey(),
        }
    });
};

export default {
  login
};
